import uuidv4 from "../../tools/guidgenerator";
import * as Constants from "../../config";
import * as Vaules from "../../static data/selectvalues";
import { useEffect, useState } from "react";
import AddReview from "./add-review";
import { useTranslation } from "react-i18next";

export default function ReviewsAdmin(){
    const { t } = useTranslation();
    const [data,setData] = useState();
    const [modalOpened,setModalOpened] = useState(false);

    const [selectedRecord,setSelectedRecord] = useState();

    function getData() {
        fetch(Constants.apiurl + Constants.reviews)
        .then((response) => response.json())
        .then((data) => {
            setData(data);
        })
        .catch((err) => {
           console.log(err.message);
        });
    }

    function closeWindow(){
        setModalOpened(false);
    }

    useEffect(() => {
        getData();
     }, []);

     function openModal(record){
        console.log(record);
        if(record == undefined){
            record = {};
            record.id = uuidv4();
        }
        setSelectedRecord(record);
        setModalOpened(true);
     }

     const saveData = (record) => {
        const body = Constants.requestBody(record);
        fetch(Constants.apiurl + Constants.reviews, body)
        .then(response => {
            if(response.status == 401) window.location.reload(false);
            return response.json();
        })
        .then(data => {
            getData();
        })
        .catch(err => {
            console.log(err.error);
        });
    }
    const deleteRecord = (x) => {
        fetch(Constants.apiurl + Constants.deletereview + "?id=" + x, Constants.requestHeaderOnly())
        .then((data) => {
            getData();
        })
        .catch((err) => {            
            console.log(err.message);
        });
    };

    return(
        <>
        { modalOpened? <AddReview record={selectedRecord} saveRecord={saveData} closeWindow={closeWindow}/> : ""}
        <h2>{t('Avis')}</h2>
        <div onClick={()=>openModal(undefined)} className="add-button">{t('Ajouter')}</div> 
        <table id='reviews-table'>
            <thead>
                <tr>
                    <th>
                        Name
                    </th>
                    <th>
                        Text
                    </th>
                    <th>{t('Actions')}</th>
                </tr>
            </thead>
            <tbody>
                {!!(data) ? data.map(x=>                
                    <tr>
                        <td>
                            {x.name}
                        </td>
                        <td>
                            {x.text}
                        </td>
                        <td id="buttons">
                            <div onClick={()=>openModal(x)} className="edit-button">{t('Editer')}</div>
                            <div onClick={()=>deleteRecord(x.id)} className="delete-button">{t('Supprimer')}</div>
                        </td>
                    </tr>
                ):""}
            </tbody>
        </table>
        </>
    )
}